var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187.318,
    height: 181.32,
    viewBox: "0 0 187.318 181.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7045",
    "data-name": "Group 7045",
    transform: "translate(-861 -44332.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-smile",
    "data-name": "Icon feather-smile",
    transform: "translate(874 44339.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10106",
    "data-name": "Path 10106",
    d: "M170.318,86.659A83.659,83.659,0,1,1,86.659,3,83.659,83.659,0,0,1,170.318,86.659Z",
    fill: "none",
    stroke: "#00bf5f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10107",
    "data-name": "Path 10107",
    d: "M12,21S24.549,37.732,45.464,37.732,78.927,21,78.927,21",
    transform: "translate(41.196 82.391)",
    fill: "none",
    stroke: "#00bf5f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M13.5,13.5h.084",
    transform: "translate(48.061 48.061)",
    fill: "none",
    stroke: "#00bf5f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M22.5,13.5h.084",
    transform: "translate(89.257 48.061)",
    fill: "none",
    stroke: "#00bf5f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-smile-2",
    "data-name": "Icon feather-smile",
    transform: "translate(862 44333.5)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10106-2",
    "data-name": "Path 10106",
    d: "M170.318,86.659A83.659,83.659,0,1,1,86.659,3,83.659,83.659,0,0,1,170.318,86.659Z",
    fill: "none",
    stroke: "#aeaeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10107-2",
    "data-name": "Path 10107",
    d: "M12,21S24.549,37.732,45.464,37.732,78.927,21,78.927,21",
    transform: "translate(41.196 82.391)",
    fill: "none",
    stroke: "#aeaeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108-2",
    "data-name": "Path 10108",
    d: "M13.5,13.5h.084",
    transform: "translate(48.061 48.061)",
    fill: "none",
    stroke: "#aeaeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109-2",
    "data-name": "Path 10109",
    d: "M22.5,13.5h.084",
    transform: "translate(89.257 48.061)",
    fill: "none",
    stroke: "#aeaeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/smile_icon.d6da215e3169418a4d19e888c949652c.svg";
export { ForwardRef as ReactComponent };